export default __webpack_public_path__ + "static/media/21.a9cb0fc4.png";